"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var idm_crosscutting_concepts_frontend_1 = require("@synisys/idm-crosscutting-concepts-frontend");
function fullParse(json) {
    try {
        var parsed = JSON.parse(json);
        return fullParse(parsed);
    }
    catch (error) {
        return json;
    }
}
exports.fullParse = fullParse;
function multilingualToString(multilingualString) {
    if (!multilingualString) {
        return '';
    }
    var obj = {};
    multilingualString.toMap().forEach(function (value, key) {
        obj[key] = value;
    });
    return JSON.stringify(obj);
}
exports.multilingualToString = multilingualToString;
function stringToMultilingual(json) {
    if (json === '') {
        return undefined;
    }
    var multilingualString = JSON.parse(json);
    var builder = idm_crosscutting_concepts_frontend_1.MultilingualString.newBuilder();
    for (var key in multilingualString) {
        if (multilingualString.hasOwnProperty(key)) {
            builder.withValueForLanguage(+key, multilingualString[key]);
        }
    }
    return builder.build();
}
exports.stringToMultilingual = stringToMultilingual;
function mapToJson(map) {
    return JSON.stringify(mapToObj(map));
}
exports.mapToJson = mapToJson;
function jsonToMap(mapStr) {
    return new Map(Object.entries(JSON.parse(mapStr)));
}
exports.jsonToMap = jsonToMap;
function mapToObj(map) {
    if (!map || isNullOrEmptyObject(map)) {
        return {};
    }
    var obj = {};
    map.forEach(function (v, k) {
        obj[k] = v;
    });
    return obj;
}
exports.mapToObj = mapToObj;
function isNullOrEmptyObject(obj) {
    return obj == null || (Object.keys(obj).length === 0 && obj.constructor === Object);
}
exports.isNullOrEmptyObject = isNullOrEmptyObject;
//# sourceMappingURL=utilities.js.map